module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_kpoti_m.42a5408ed7ddff932284d94ebdadd08a.png";